import { combineReducers } from "redux";
import { loginAlerts } from "./login.reducer";
import { slidesReducer } from "./slides.reducer";
import { searchReducer } from "./search.reducer";
import { deviceAlert } from "./device.reducer";
import { dashboardReducer } from "./dashboard.reducer"
import { deviceStatusReducer } from "./device_status.reducer";
import { utilsReducer } from "./utils.reducer";
import { previewStatusReducer } from "./preview_status.reducer";
import {olAlert} from './ol.reducer';
import {annoUpdate} from './anno.reducer'
import {liveViewReducer} from './liveview.reducer'
import {viewerSettingReducer} from './viewerSettings.reducer'
import {viewerUrlReducer} from './morpheus.state.reducer'

export const rootReducer = combineReducers({
  loginAlerts,
  slidesReducer,
  searchReducer,
  deviceAlert,
  dashboardReducer, 
  deviceStatusReducer,
  utilsReducer,
  previewStatusReducer,
  liveViewReducer, 
  olAlert,
  annoUpdate,
  viewerSettingReducer, 
  viewerUrlReducer
}); 